'use client'
import React, { useState, useEffect, useRef } from 'react'

const AnimatedCounter = ({ value }) => {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const hasAnimated = useRef(false); 

  useEffect(() => {
    const element = ref.current;

    let observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true;

          let start = 0;
          let end = parseInt(value.replace("+", ""));
          let duration = 1500;
          let step = Math.ceil(end / (duration / 16));

          const counter = setInterval(() => {
            start += step;
            if (start >= end) {
              setCount(end);
              clearInterval(counter);
            } else {
              setCount(start);
            }
          }, 16);
        }

        if (!entry.isIntersecting) {
          hasAnimated.current = false;
          setCount(0);
        }
      },
      { threshold: 0.4 }
    );

    if (element) observer.observe(element);

    return () => observer.disconnect();
  }, [value]);

  return (
    <span ref={ref}>
      {count}{value.includes("+") ? "+" : ""}
    </span>
  );
};

export default AnimatedCounter;
